<template>
  <v-dialog
    v-model="isVisible"
    no-click-animation
    :width="'55%'"
  >
    <v-card>
      <v-card-title>
        <h3>首期繳款日</h3>
      </v-card-title>
      <v-card-text>
        <date-picker :date-string="`首期繳款日`" :date.sync="firstPaymentDate"/>
      </v-card-text>
      <v-card-actions>
        <v-btn class="red" dark text @click="cancelEvent">取消</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="primary" dark text @click="confirmEvent">確認</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DatePicker from "../components/DatePicker";
import { getCurrentDate } from '@/pages/utils/tool';
export default {
  name: 'FirstDateDialog',
  components: {
    DatePicker
  },
  props:{
    visible: Boolean,
  },
  watch: {
    visible(value) {
      this.isVisible = value;
    },
    isVisible(value) {
      if (!value) {
        this.cancelEvent()
      }
    },
  },
  data() {
    return {
      firstPaymentDate: getCurrentDate(),
      isVisible: false,
    };
  },
  methods: {
    cancelEvent(){
      this.isVisible = false;
      this.$emit('cancelEvent');
    },
    confirmEvent(){
      this.isVisible = false;
      this.$emit('confirmEvent', this.firstPaymentDate);
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/FirstDateDialog.vue